import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { ReservationCompare } from '../models/reservation-compare';
import { ReservationCompareStore } from '../service/reservation-compare-store';
import { LogService } from '../../shared/log/log.service';

@Injectable()
export class RsvpCompareResolver implements Resolve<any> {
  private previousRoute: string = null;

  constructor(private reservationCompareStore: ReservationCompareStore,
              private translateService: TranslateService,
              private logService: LogService,
              private router: Router) {
    // This code is required in order to know the previous route in resolve.
    // Note that first the NavigationStart event will happen, then resolve() is called if the resolver is attached
    // to the route, then NavigationEnd happens.
    this.router.events
      .filter(e => e instanceof NavigationEnd)
      .subscribe((e: NavigationEnd) => {
        this.previousRoute = e.url;
      });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<ReservationCompare>> {
    const id = route.params[ 'id' ];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RSVPS'));
    }

    return this.reservationCompareStore.getRsvps(route.params[ 'id' ]).first();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/rsvp/rsvp-compare.resolver.ts